import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./style.css"; // Create this CSS file for additional styling

const LazyImage = ({ src, alt, placeholderSrc, height, width }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div
      style={{
        height: height,
        width: width,
        overflow: "hidden", // Ensures no overflow from the image
      }}
    >
      {!loaded && (
        <img
          src={placeholderSrc}
          alt="placeholder"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover", // Ensures placeholder fits nicely
          }}
        />
      )}
      <LazyLoadImage
        alt={alt}
        src={src}
        effect="blur"
        afterLoad={() => setLoaded(true)}
        className={`main-image ${loaded ? "loaded" : "loading"}`}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover", // Ensures the image fits fully within the given height and width
        }}
      />
    </div>
  );
};

export default LazyImage;
